import { render, staticRenderFns } from "./IconPaymentIDeal.vue?vue&type=template&id=e964169e&scoped=true"
import script from "./IconPaymentIDeal.vue?vue&type=script&lang=js"
export * from "./IconPaymentIDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e964169e",
  null
  
)

export default component.exports